import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import { Event, Profile } from '@bimdata/definitions/dto';
import { get as getProject } from '@/api/project';

export default async function (event: Event, profile: Profile) {
  const { projectCode, userId, blocked } = event.data;

  if (userId === profile.id) {
    if (blocked) {
      store.dispatch(projectSlice.actions.removeProject(projectCode));
    } else {
      let project = null;
      try {
        project = await getProject(projectCode);
      } catch (error) {
        if (error.code !== 404) {
          throw error;
        }
      }
      if (project) {
        store.dispatch(projectSlice.actions.created(project));
      }
    }
  } else {
    store.dispatch(
      projectSlice.actions.setParticipantsBlocked({
        code: projectCode,
        ids: [userId],
        blocked
      })
    );
  }
};
